<div class="">
  @if (!helper.currentAssetId()) {
    <div class="p-(--padding-card) text-center bg-yellow-100 border border-yellow-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'common.messages.noAssetSelected.auscultationInfos' | transloco }}</p>
    </div>
  }
  <ces-generic-parent-grid
    [hasPermission]="tablePermissionConfig()"
    [entityDefinition]="entityDefinitionWithPermissions()"
    [entities]="helper.state.data()"
    [paginator]="true"
    [totalRecords]="helper.state.totalRecords()"
    [first]="helper.state.first()"
    [rows]="helper.state.rows()"
    [dataLoadingCompleted]="helper.state.dataLoadingCompleted()"
    [stateKey]="gridStateKey()"
    (lazyLoad)="onLazyLoad($event)"
    (createEntity)="createAuscultationInfo()"
    (deleteEntity)="deleteAuscultationInfo($event)" />
</div>
